__turbopack_context__.v({
  "cell": "style-module-scss-module__kq-xOG__cell",
  "cell-label": "style-module-scss-module__kq-xOG__cell-label",
  "cell-value": "style-module-scss-module__kq-xOG__cell-value",
  "component": "style-module-scss-module__kq-xOG__component",
  "is-private": "style-module-scss-module__kq-xOG__is-private",
  "no-flooring": "style-module-scss-module__kq-xOG__no-flooring",
  "table": "style-module-scss-module__kq-xOG__table",
  "table-head": "style-module-scss-module__kq-xOG__table-head",
  "table-header": "style-module-scss-module__kq-xOG__table-header",
  "table-row": "style-module-scss-module__kq-xOG__table-row",
  "table-variant": "style-module-scss-module__kq-xOG__table-variant",
  "three-columns": "style-module-scss-module__kq-xOG__three-columns",
  "units-toggle": "style-module-scss-module__kq-xOG__units-toggle",
});
